import Seo from "@/components/base/Seo";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "./components/Hero";
import HotRanking from "./components/HotRanking";
import LatestUpdates from "./components/LatestUpdates";
import CategoryBrowse from "./components/CategoryBrowse";
import Spotlight from "./components/Spotlight";
import Features from "./components/Features";
import Faq from "./components/Faq";
import CtaBanner from "./components/CtaBanner";

const siteUrl = "https://teachmanga4.github.io/";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "在178漫画网看《家庭教师》需要付费吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "不需要付费。178漫画网提供《家庭教师》等漫画的在线免费阅读服务，所有章节均可直接阅读，无需充值或购买会员。",
      },
    },
    {
      "@type": "Question",
      name: "什么是下拉式漫画阅读？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "下拉式漫画阅读是指漫画图片从上到下连续排列，您只需向下滑动屏幕即可一页页阅读，无需频繁点击翻页按钮，解放双手，浏览体验更加流畅便捷。",
      },
    },
    {
      "@type": "Question",
      name: "《家庭教师》漫画多久更新一次？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "178漫画网会第一时间同步《家庭教师》等热门漫画的最新章节，通常每日更新，您可以在「最近更新」板块查看最新上架的章节。",
      },
    },
  ],
};

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Seo
        title="《家庭教师》漫画-在线免费阅读下拉式漫画-178漫画网"
        description="通过178漫画网在线免费阅读《家庭教师》下拉式漫画，便捷的浏览方式解放您的双手。家庭教师漫画免费在线看，下拉式阅读，更新及时，178漫画网为您提供优质阅读体验。"
        keywords="家庭教师,在线免费阅读,下拉式漫画,178漫画网,家庭教师漫画"
        canonical={siteUrl}
        image="https://readdy.ai/api/search-image?query=stylized%20artistic%20illustration%20of%20an%20orange%20flame%20rising%20against%20a%20dark%20manga%20city%20skyline%20at%20dusk%2C%20warm%20ember%20particles%20floating%2C%20dramatic%20shonen%20anime%20atmosphere%2C%20deep%20contrast%20between%20bright%20flame%20and%20shadow%2C%20abstract%20artistic%20composition%2C%20no%20text&width=1600&height=900&seq=og-cover-home&orientation=landscape"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "《家庭教师》漫画-在线免费阅读下拉式漫画-178漫画网",
            url: siteUrl,
            inLanguage: "zh-CN",
            isPartOf: { "@type": "WebSite", name: "178漫画网", url: siteUrl },
            description:
              "通过178漫画网在线免费阅读《家庭教师》下拉式漫画，便捷的浏览方式解放您的双手。",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: siteUrl },
            ],
          },
          faqJsonLd,
        ]}
      />

      <Navbar />
      <main id="main-content" className="flex-1">
        <Hero />
        <HotRanking />
        <LatestUpdates />
        <CategoryBrowse />
        <Spotlight />
        <Features />
        <Faq />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}